module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-300.3352653dedd571bbc490.ttf";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-300.ttf
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-300.ttf
// module chunks = styles